module.exports = __webpack_public_path__ + "img/蒙版组 57.c288801f.png";